import React from "react";
import PropTypes from "prop-types";
//Material imports
import makeStyles from "@mui/styles/makeStyles";
import Grid from "@mui/material/Grid";
//Limitless imports
import Typography from "@mui/material/Typography";

const useStyles = makeStyles({
    container: {
        display: "flex",
        flexDirection: "row"
    },
    text: {
        margin: "0px 8px 2px 3px!important",
        display: "flex",
        alignItems: "end"
    },
    textvalue: {
        margin: "0px!important",
        fontSize: 20,
        fontWeight: 500
    }
});

const DashboardCommonTooltip = ({ date, value, valueText, category, colorsGrid, categoryLabel, className, theme }) => {
    const classes = useStyles();

    return (
        <div
            className={theme.palette.mode === "dark" ? `${className}_dark` : className}
            style={{ backgroundColor: theme.palette.background.elevation2 }}
        >
            <Typography variant="caption" style={{ marginTop: "0px!important", color: theme.palette.text.secondary }}>
                {date}
            </Typography>
            <Grid
                className={classes.container}
                style={{
                    marginTop: "5px"
                }}
            >
                <Typography variant="h2" className={classes.textvalue} style={{ color: theme.palette.text.primary }}>
                    {value}
                </Typography>
                <Typography
                    variant="caption"
                    className={classes.text}
                    style={{ color: theme.palette.text.secondary, textAlign: "end" }}
                >
                    {valueText}
                </Typography>
            </Grid>
            {category && (
                <Grid
                    className={classes.container}
                    style={{
                        marginTop: "8px"
                    }}
                >
                    {category?.map((cat, index) => {
                        return (
                            <Grid
                                key={cat}
                                style={{
                                    display: "flex",
                                    flexDirection: "row"
                                }}
                            >
                                <span className="tooltip-marker" style={{ backgroundColor: `${colorsGrid[index]}` }} />
                                <Typography
                                    variant="caption"
                                    style={{ color: theme.palette.text.secondary, margin: "0px!important" }}
                                >
                                    {category[index]}
                                </Typography>
                                <Typography
                                    variant="caption"
                                    style={{ color: theme.palette.text.secondary }}
                                    className={classes.text}
                                >
                                    {categoryLabel[index]}
                                </Typography>
                            </Grid>
                        );
                    })}
                </Grid>
            )}
        </div>
    );
};
DashboardCommonTooltip.propTypes = {
    date: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    valueText: PropTypes.string,
    className: PropTypes.string,
    category: PropTypes.array,
    categoryLabel: PropTypes.array,
    colorsGrid: PropTypes.any,
    theme: PropTypes.object
};
export default DashboardCommonTooltip;
